import { UserRole } from '@shared/types';

//* 릴리즈 노트 채널 — docs/releases/README.md의 채널 표와 1:1
export type ReleaseNoteChannel =
  | 'admin'
  | 'agency-admin'
  | 'agency-worker'
  | 'brand'
  | 'mari-gift'
  | 'mari-seller';

export interface ReleaseNoteEntry {
  releaseId: string;
  channel: string;
  title: string;
  /** 본문 도입부 한 줄 — 목록에서 "무슨 배포였는지" 보여주는 용도 */
  summary: string;
  /** 이 노트의 중요 포인트 (본문 h2 제목들) */
  points: string[];
  body: string;
}

export const RELEASE_NOTE_CHANNEL_LABEL: Record<ReleaseNoteChannel, string> = {
  admin: '관리자',
  'mari-gift': '답례품팀',
  'mari-seller': '화환팀',
  brand: '공급사·배송관리자',
  'agency-admin': '상조 관리자',
  'agency-worker': '상조 팀장·직원',
};

//* 화면 노출 순서 (탭 정렬용)
export const RELEASE_NOTE_CHANNEL_ORDER: ReleaseNoteChannel[] = [
  'admin',
  'mari-gift',
  'mari-seller',
  'brand',
  'agency-admin',
  'agency-worker',
];

//* role → 볼 수 있는 채널.
//* 지금은 Admin만 페이지가 열려 있고(전 채널 열람), 나머지 role은 확장 단계에서
//* 각 콘솔에 라우트를 붙일 때 이 표를 그대로 쓰면 된다.
export const RELEASE_NOTE_ROLE_CHANNELS: Partial<Record<UserRole, ReleaseNoteChannel[]>> =
  {
    [UserRole.Admin]: RELEASE_NOTE_CHANNEL_ORDER,
    [UserRole.GiftAgent]: ['mari-gift'],
    [UserRole.StoreSeller]: ['mari-seller'],
    [UserRole.StoreSellerAdmin]: ['mari-seller'],
    [UserRole.StoreSellerWorker]: ['mari-seller'],
    [UserRole.GiftBrandSeller]: ['brand'],
    [UserRole.BugoAgencyAdmin]: ['agency-admin'],
    [UserRole.BugoAgencyBranchAdmin]: ['agency-admin'],
    [UserRole.BugoAgencyWorker]: ['agency-worker'],
    [UserRole.BugoFuneralHome]: ['agency-worker'],
  };
